import cn from 'classnames';
import React, { FC } from 'react';

import * as styles from './Burger.module.css';

type IBurgerProps = {
	onClick(event: React.MouseEvent<HTMLButtonElement>): void;
	active: boolean;
};

const Burger: FC<IBurgerProps> = ({ onClick, active = false }) => {
	const classes = cn({
		[styles.hamburger]: true,
		[styles.isActive]: active,
	});

	return (
		<button
			onClick={onClick}
			className={classes}
			type="button"
			aria-label={active ? 'Close Menu' : 'Open Menu'}>
			<span className={styles.hamburgerBox}>
				<span className={styles.hamburgerInner} />
			</span>
		</button>
	);
};

export default Burger;
